// client/src/services/index.js
import matchProposalService from './MatchProposalService'
import schedulingService from './SchedulingService'
import availabilityService from './AvailabilityService'
import matchService from './MatchService'
import leagueService from './LeagueService'
import adminToolsService from './AdminToolsService'

export { default as BaseService } from './BaseService'
export { default as MatchProposalService } from './MatchProposalService'
export { default as SchedulingService } from './SchedulingService'
export { default as AvailabilityService } from './AvailabilityService'
export { default as MatchService } from './MatchService'
export { default as LeagueService } from './LeagueService'
export { default as AdminToolsService } from './AdminToolsService'

// For convenience, also export the singleton instances

export const services = {
  matchProposal: matchProposalService,
  scheduling: schedulingService,
  availability: availabilityService,
  match: matchService,
  league: leagueService,
  adminTools: adminToolsService,
}

export default services
